import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useMicReturnReasons = () => {

    const [reasonsMic, setReasonsMic] = useState([]);
    const [reasonsId, setReasonsId] = useState(0);
    const [dataReasonsSearch, setReasonsSearch] = useState([]);


    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const history = useHistory();
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    const [formValues, handleInputChange, reset, handleUpdateValues,] = useForm({
        return_reason: "",
    });
    const [validaciones, setValidaciones] = useState({
        name_valid: false,
    })
    const { return_reason, } = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(reasonsMic.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listReasons = [];
        reasonsMic.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listReasons.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setReasonsMic(listReasons);
    }, [totalPageCount, currentPage])

    // const toggle = () => {
    //     setModal(!modal);
    // }

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };
    

    useEffect(() => {
        getReasons();
    }, [history.location]);


    const getReasons = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "ReturnReasonMicro/List");
        console.log(respuesta, "respuesta del backend");

        if (respuesta.code === 200) {
            let listReasons = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach((data, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    listReasons.push({
                        id_mic_return_reason: data.id_mic_return_reason,
                        return_reason: data.return_reason,
                        visibleTable: visibleTable
                    });
                });
                setReasonsMic(listReasons);
                setReasonsSearch(listReasons);
            }
        }
    }


    const handleCreate = () => {
        handleUpdateValues({
            return_reason: "",
        });

        setReasonsId(0);
        setMethod("create");
        setModalTitle("Crear nueva razón de rechazo");
        openDialog("Crear nueva razón de rechazo", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "ReturnReasonMicro");
        if (respuesta.code === 200) {
            getReasons();
            createSweet("create", "success", "Éxito!", "Razón de rechazo creada con éxito");
            setLoading(false);
            closeDialog();
        }
    }

    const handleUpdate = (id_mic_return_reason) => {
        let reasons = reasonsMic.find(s => s.id_mic_return_reason === id_mic_return_reason);

        handleUpdateValues({
            return_reason: reasons.return_reason,
        });

        setValidaciones({
            name_valid: false,
        });

        setReasonsId(id_mic_return_reason);
        setMethod("update");
        setModalTitle("Modificación del contenedor");
        openDialog("Modificar razón de rechazo", "update");
    }
   
    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_mic_return_reason: reasonsId,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);

        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "ReturnReasonMicro/Update");

        if (respuesta.code === 200) {
            getReasons();
            createSweet("create", "success", "Exito!", "Razón de rechazo actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }



    const handleDelete = (id_mic_return_reason) => {

        let reasons = reasonsMic.find(s => s.id_mic_return_reason === id_mic_return_reason);

        handleUpdateValues({
            return_reason: reasons.return_reason,
        });

        setReasonsId(id_mic_return_reason);
        setMethod("delete");
        setModalTitle("Eliminar razón");
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `ReturnReasonMicro/${reasonsId}`);

        if (respuesta.code === 200) {
            getReasons();
            setLoading(false);
            createSweet("create", "success", "Exito!", "Razón de rechazo eliminada");
            closeDeleteAlert();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.return_reason === "" || formValues.return_reason.length < 3) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_valid: false
            }
        }
        setValidaciones(newValidations);

        return statusValidation;
    }


    // const handleSearchReason = (e) => {

    //     let busqueda = e.target.value;
    //     let newMethod = [];

    //     dataReasonsSearch.forEach(element => {

    //         let cadena = element.return_reason.toUpperCase();
    //         if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
    //             element.visibleTable = true;
    //             newMethod.push(element);
    //         }
    //     });
    //     setReasonsMic(newMethod);
    // }


    const handleExcelReasons = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

            const _report = reasonsMic.map((item, index) => ({
                "#": index + 1,
                "Razón de rechazo": item.return_reason || "---",                
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listado_razones_rechazo");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catálogo_razones_rechazo.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };


   const [searchReasons, setSearchReasons] = useState("");

    const handleSearch = (e) => {
        setSearchReasons(e);

        let busqueda = e.toUpperCase();
        let newReasons = [];

        if (busqueda === "") {
            setReasonsMic([...dataReasonsSearch]); 
        } else {
            dataReasonsSearch.forEach(element => {
                let cadena = element.return_reason.toUpperCase();
                if (cadena.indexOf(busqueda) > -1) {
                    newReasons.push(element);
                }
            });
            setReasonsMic(newReasons);
        }
    }

    const handleClear = () => {
        setSearchReasons("");                         
        localStorage.removeItem("globalFilter");    
        setReasonsMic([...dataReasonsSearch]);
    };

    return {
        reasonsMic, return_reason, validaciones,
        method,
        handleInputChange, loading,
        modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        closeDeleteAlert, modalAlert, showDeleteAlert, closeDialog,
        handleExcelReasons, loadingExport,
        handleClear, handleSearch, searchReasons
    }

}




